import React, { useState } from "react";
import "./My_History.css";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomPagination from "../../../Common/Common_Component/CustomPagination/CustomPagination";

function My_History() {
  const [expandedIndex, setExpandedIndex] = useState(0);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  // Full dataset containing all types: Color, Text, and Number
  const historyData = [
    {
      id: "202602209100051226",
      date: "2026-02-20 12:24:16",
      variant: "red",
      type: "color", // Type 1: Color Gradient
      status: "Succeed",
      amount: "+₹ 8.34",
      details: {
        orderNumber: "WG2026020806541699203201970865",
        period: "202602209100051226",
        purchaseAmount: "₹ 5.00",
        quantity: "10",
        amountAfterTax: "₹ 5.00",
        tax: "₹ 5.00",
        result: { num: 0, colors: ["Red", "Violet"], size: "Small" },
        select: "Red",
        winLose: "+ ₹67.89",
        orderTime: "2026-02-04 12:23:18",
      },
    },
    {
      id: "202602209100051227",
      date: "2026-02-20 12:25:00",
      variant: "blue",
      type: "text", // Type 2: Text Label (Small/Big)
      label: "Small",
      status: "Succeed",
      amount: "+₹ 8.34",
      details: {
        orderNumber: "WG...227",
        period: "2026...227",
        purchaseAmount: "₹ 10.00",
        quantity: "1",
        amountAfterTax: "₹ 9.80",
        tax: "₹ 0.20",
        result: { num: 2, colors: ["Red"], size: "Small" },
        select: "Small",
        winLose: "+ ₹19.60",
        orderTime: "2026-02-20 12:25:00",
      },
    },
    {
      id: "202602209100051228",
      date: "2026-02-20 12:26:10",
      variant: "red",
      type: "number", // Type 3: Number Selection
      label: "6",
      status: "Failed",
      amount: "-₹ 8.34",
      details: {
        orderNumber: "WG...228",
        period: "2026...228",
        purchaseAmount: "₹ 5.00",
        quantity: "1",
        amountAfterTax: "₹ 4.90",
        tax: "₹ 0.10",
        result: { num: 3, colors: ["Green"], size: "Small" },
        select: "6",
        winLose: "- ₹5.00",
        orderTime: "2026-02-20 12:26:10",
      },
    },
    {
      id: "202602209100051229",
      date: "2026-02-20 12:27:00",
      variant: "green",
      type: "number",
      label: "3",
      status: "Failed",
      amount: "-₹ 8.34",
      details: {
        orderNumber: "WG...229",
        period: "2026...229",
        purchaseAmount: "₹ 5.00",
        quantity: "1",
        amountAfterTax: "₹ 4.90",
        tax: "₹ 0.10",
        result: { num: 8, colors: ["Red"], size: "Big" },
        select: "3",
        winLose: "- ₹5.00",
        orderTime: "2026-02-20 12:27:00",
      },
    },
  ];

  return (
    <>
      <section className="My_History">
        <div className="my-history-container">
          <table className="main-history-table">
            <tbody>
              {historyData.map((item, index) => {
                const isExpanded = expandedIndex === index;
                return (
                  <React.Fragment key={index}>
                    <tr
                      className="history-header-row"
                      onClick={() => toggleExpand(index)}
                    >
                      <td className="col-icon">
                        <div className={`icon-box bg-${item.variant}`}>
                          {item.type !== "color" ? item.label : ""}
                        </div>
                      </td>
                      <td className="col-info">
                        <div className="id-text">
                          {item.id}
                          <span className="arrow">
                            <FontAwesomeIcon
                              icon={isExpanded ? faSortUp : faSortDown}
                            />
                          </span>
                        </div>
                        <div className="date-text">{item.date}</div>
                      </td>
                      <td className="col-status">
                        <div
                          className={`status-wrapper ${item.status.toLowerCase()}`}
                        >
                          <div className="status-badge">{item.status}</div>
                          <div className="amount-text">{item.amount}</div>
                        </div>
                      </td>
                    </tr>

                    {/* Transition Wrapper */}
                    <tr
                      className={`details-expanded-row ${
                        isExpanded ? "is-open" : ""
                      }`}
                    >
                      <td colSpan="3">
                        <div className="accordion-wrapper">
                          <div className="accordion-content">
                            <div className="details-inner-wrapper">
                              <h3 className="details-heading">Details</h3>
                              <table className="details-data-table">
                                <tbody>
                                  <tr>
                                    <td>Order Number</td>
                                    <td className="order-val">
                                      {item.details?.orderNumber} 📋
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Period</td>
                                    <td>{item.details?.period}</td>
                                  </tr>
                                  <tr>
                                    <td>Purchase amount</td>
                                    <td>{item.details?.purchaseAmount}</td>
                                  </tr>
                                  <tr>
                                    <td>Quantity</td>
                                    <td>{item.details?.quantity}</td>
                                  </tr>
                                  <tr>
                                    <td>Amount after tax</td>
                                    <td className="clr-red">
                                      {item.details?.amountAfterTax}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Tax</td>
                                    <td>{item.details?.tax}</td>
                                  </tr>
                                  <tr>
                                    <td>Result</td>
                                    <td>
                                      {item.details?.result.num}
                                      <span className="clr-red">
                                        {" "}
                                        {item.details?.result.colors[0]}
                                      </span>
                                      {item.details?.result.colors[1] && (
                                        <span className="clr-violet">
                                          {" "}
                                          {item.details?.result.colors[1]}
                                        </span>
                                      )}
                                      <span className="clr-blue">
                                        {" "}
                                        {item.details?.result.size}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Select</td>
                                    <td className="clr-red">
                                      {item.details?.select}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Status</td>
                                    <td className="clr-green">{item.status}</td>
                                  </tr>
                                  <tr>
                                    <td>Win/ Lose</td>
                                    <td
                                      className={
                                        item.status === "Succeed"
                                          ? "clr-green"
                                          : "clr-red"
                                      }
                                    >
                                      {item.details?.winLose}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Order Time</td>
                                    <td>{item.details?.orderTime}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>
      <CustomPagination />
    </>
  );
}

export default My_History;
